import { render, staticRenderFns } from "./work-bench.vue?vue&type=template&id=abb9d18e&scoped=true"
import script from "./work-bench.vue?vue&type=script&lang=js"
export * from "./work-bench.vue?vue&type=script&lang=js"
import style0 from "./work-bench.vue?vue&type=style&index=0&id=abb9d18e&prod&lang=scss&scoped=true"
import style1 from "./work-bench.vue?vue&type=style&index=1&id=abb9d18e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb9d18e",
  null
  
)

export default component.exports